import React, { useMemo } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { useBenefisCategoryUIContext } from "./BenefisCategoryUIContext";
import BenefisCategoryTable from "./benefis-category-table/BenefisCategoryTable";
import { BenefisCategoryFilter } from "./benefis-category-filter/BenefisCategoryFilter";
import { RoleChecker } from "../../../RoleChecker";

export const BenefisCategoryCard = () => {
  const benefisCategoryUIContext = useBenefisCategoryUIContext();
  const benefisCategoryUIProps = useMemo(() => {
    return {
      newBenefisCategoryButtonClick:
        benefisCategoryUIContext.newBenefisCategoryButtonClick,
    };
  }, [benefisCategoryUIContext]);

  return (
    <Card>
      <CardHeader title="Kategori Penerima Manfaat">
        <CardHeaderToolbar>
          {RoleChecker("Create", "benefis_category") && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={benefisCategoryUIProps.newBenefisCategoryButtonClick}
            >
              Kategori Baru
            </button>
          )}
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <BenefisCategoryFilter />
        <BenefisCategoryTable />
      </CardBody>
    </Card>
  );
};
